import { TEmployeeRole, TNeedleActionPermissions, TRESPONSE_NEEDLE_LIST } from '@monorepo/types';
import { ACCORDION_TABLE_MODIFIER } from '../../model/accordion-table.modifier';
import { TAccordionTableVM } from '../../model/accordion-table.types';

function _getLocationDisplayStr(localInventory: TRESPONSE_NEEDLE_LIST['needles'][number]['localStoreDetails'][number]) {
  switch (localInventory.location.locationType) {
    case 'FLOOR_NEEDLE_STORE': {
      return `Floor ${localInventory.location.floor}`;
    }
    case 'SECTION_NEEDLE_STORE': {
      return `Section ${localInventory.location.section}`;
    }
    default:
      return '';
  }
}

export const NEEDLE_LIST_ACCORDION_TABLE_MODEL = {
  createModel(
    items: TRESPONSE_NEEDLE_LIST['needles'],
    selectedNeedles: TRESPONSE_NEEDLE_LIST['needles'],
    employeeRole?: TEmployeeRole[number] | undefined,
    needleActionPermissions?: TNeedleActionPermissions,
  ): TAccordionTableVM {
    const isAdminLikeUser = !!items[0]?.mainStoreDetailsOpt;

    return ACCORDION_TABLE_MODIFIER.createModel(
      employeeRole === 'FACTORY_GROUP_ADMIN'
        ? [
            { label: 'table_model.FACTORYID', colSize: 8 },
            { label: 'table_model.NEEDLESIZE', colSize: 7 },
            { label: 'table_model.NEEDLEPOINT', colSize: 7 },
          ]
        : [
            { label: 'table_model.NEEDLETYPE', colSize: 8 },
            { label: 'table_model.NEEDLESIZE', colSize: 7 },
            { label: 'table_model.NEEDLEPOINT', colSize: 7 },
          ],

      items.map((item) => ({
        id: item.needleId,
        isMinimized: true,
        accordionSelectionInfo: {
          isDisabled: false,
          isSelected: selectedNeedles.some((n) => n.needleId === item.needleId),
        },
        moreInfo: [
          {
            items: [
              {
                size: 12,
                label: 'table_model.SIZE',
                values: [{ displayName: item.size }],
              },
              {
                size: 12,
                label: 'table_model.COATING',
                values: [{ displayName: item.coating || '--' }],
              },
              {
                size: 12,
                label: 'table_model.BRAND',
                values: [{ displayName: item.brand }],
              },
              {
                size: 12,
                label: 'table_model.NEEDLENUMBER',
                values: [{ displayName: item.needleNumber }],
              },
              isAdminLikeUser
                ? {
                    size: 12,
                    label: 'table_model.MAINSTOREQUANTITY',
                    values: [{ displayName: item.mainStoreDetailsOpt?.quantity || '--' }],
                  }
                : {
                    size: 12,
                    label: 'table_model.LOCALINVENTORY',
                    values: [
                      {
                        displayName:
                          item.localStoreDetails.length > 0
                            ? `${_getLocationDisplayStr(item.localStoreDetails[0])}, ${
                                item.localStoreDetails[0].quantity
                              }`
                            : '--',
                      },
                    ],
                  },
              {
                size: 12,
                label: 'table_model.IN-USEQUANTITY',
                values: [{ displayName: item.inUseQuantity }],
              },
            ],
          },
        ],
        rowItems:
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? [
                { type: 'TEXT', value: item.factoryId.toString() },
                { type: 'TEXT', value: item.size },
                { type: 'TEXT', value: item.point },
              ]
            : [
                { type: 'TEXT', value: item.needleType },
                { type: 'TEXT', value: item.size },
                { type: 'TEXT', value: item.point },
              ],
        actions: [
          ...(needleActionPermissions?.canRaiseRequest
            ? [{ actionId: 'RAISE_REQUEST', displayName: 'needle_listing.RaiseaRequest' }]
            : []),
          ...(needleActionPermissions?.canEditNeedle
            ? [
                { actionId: 'EDIT', displayName: 'tm_common.Edit' },
                { actionId: 'DELETE_ROW', displayName: 'listing_common.DeleteRow' },
              ]
            : []),
        ],
      })),
      {
        showExpand: false,
        select:
          needleActionPermissions?.canRaiseRequest || needleActionPermissions?.canEditNeedle
            ? { isMulti: true }
            : undefined,
      },
    );
  },

  deselectAllAccordions(prev: TAccordionTableVM): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.deselectAllAccordions(prev);
  },
};
